// extracted by mini-css-extract-plugin
export default {"selectWrapper":"SelectRegion_selectWrapper__8yWNa","loading":"SelectRegion_loading__dV2dh"};